import { render, staticRenderFns } from "./PaymentCRM.vue?vue&type=template&id=2ba51ff1&"
import script from "./PaymentCRM.vue?vue&type=script&lang=js&"
export * from "./PaymentCRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports